/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { RequestBuilder } from '../../request-builder';
import { StrictHttpResponse } from '../../strict-http-response';

export interface DeleteTableViewFromRegisteredUser1$Params {}

export function deleteTableViewFromRegisteredUser1(
  http: HttpClient,
  rootUrl: string,
  params?: DeleteTableViewFromRegisteredUser1$Params,
  context?: HttpContext,
): Observable<StrictHttpResponse<string>> {
  const rb = new RequestBuilder(rootUrl, deleteTableViewFromRegisteredUser1.PATH, 'delete');
  if (params) {
  }

  return http.request(rb.build({ responseType: 'json', accept: 'application/json', context })).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<string>;
    }),
  );
}

deleteTableViewFromRegisteredUser1.PATH = '/service/v1/automatedUiTesting/tableViewAdministration';
